import axios from "axios";

export const fetchBookingAnalytics = async (params = {}) => {
  const res = await axios.get("http://localhost:5000/api/analytics/bookings", {
    params,
  });
  return res.data;
};
